const HouseCheck = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="icon-house-check"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m24,9.986v2.042c-.305-.362-.64-.696-1-1.003v-1.039c0-.517-.242-1.015-.648-1.333,0,0,0,0,0,0h0S13.042,1.359,13.042,1.359c-.613-.48-1.469-.48-2.083,0L1.649,8.653c-.407.318-.649.816-.649,1.333v13.014h10.026c.306.36.641.695,1.003,1H0v-14.014c0-.822.386-1.614,1.032-2.12L10.341.572c.977-.766,2.341-.766,3.317,0l9.31,7.294h0c.646.506,1.032,1.298,1.032,2.12Zm0,7.514c0,3.584-2.916,6.5-6.5,6.5s-6.5-2.916-6.5-6.5,2.916-6.5,6.5-6.5,6.5,2.916,6.5,6.5Zm-1,0c0-3.032-2.467-5.5-5.5-5.5s-5.5,2.468-5.5,5.5,2.467,5.5,5.5,5.5,5.5-2.468,5.5-5.5Zm-6.02,1.451c-.055.057-.179.055-.241-.006l-1.856-1.8-.696.719,1.851,1.794c.221.221.514.342.825.342s.604-.121.822-.339l3.457-3.399-.701-.713-3.46,3.402Z" />
    </svg>
  );
};

export default HouseCheck;
